import { CSSProperties } from "react";
import { useDecryptedImage } from "../hooks/useDecryptedImage";
import { Spinner } from "./ui/Spinner";
import { EmptyState } from "./ui/EmptyState";

interface DecryptedImageProps {
  // Opaque ciphertext blob reference (a server-minted proxy URL), not a directly
  // renderable image URL.
  token: string | null | undefined;
  alt: string;
  className?: string;
  style?: CSSProperties;
  onClick?: () => void;
}

// Full-size <img> whose source is an encrypted blob. Mirrors DecryptedAvatar but
// renders a plain <img> (the meal photo and the full-size photo viewer). Shows a
// Spinner while decrypting and an EmptyState fallback on failure.
export function DecryptedImage({ token, alt, className, style, onClick }: DecryptedImageProps) {
  const { url, loading, error } = useDecryptedImage(token ?? null);

  if (loading) {
    return (
      <div className={className} style={style}>
        <Spinner />
      </div>
    );
  }

  if (error || !url) {
    return <EmptyState>Photo unavailable</EmptyState>;
  }

  return <img src={url} alt={alt} className={className} style={style} onClick={onClick} />;
}
